import {useEffect} from 'react';
import {Helmet} from 'react-helmet-async';
import {useLocation} from 'react-router-dom';
import Hero from '../components/Hero';
import CurriculumGrid from '../components/CurriculumGrid';
import StudyTools from '../components/StudyTools';

function HomePage({domains,completedLessons}) {
  const location=useLocation();

  useEffect(()=> {
    const section=new URLSearchParams(location.search).get('section');

    if (!section) return;

    requestAnimationFrame(()=> {
      document.getElementById(section)?.scrollIntoView({behavior: 'smooth'});
    });
  },[location.search]);

  useEffect(()=> {
    window.prerenderReady=false;

    const frame=window.requestAnimationFrame(()=> {
      window.prerenderReady=true;
    });

    return ()=> {
      window.cancelAnimationFrame(frame);
      window.prerenderReady=false;
    };
  },[]);

  return (
    <>
      <Helmet>
        <title>Medical Coding Classes Online | Top Cert Prep & Guides</title>
        <meta
          name="description"
          content="Ace your certification exam with our medical coding classes online, interactive study tools, flashcards, & practice quizzes. Start studying today!"
        />
      </Helmet>

      <main>
        <Hero />
        <CurriculumGrid
          domains={domains}
          completedLessons={completedLessons}
        />
        <StudyTools />
      </main>
    </>
  );
}

export default HomePage;